import React from "react";
import { hospital1, hospital2, hospital3, hospital4, hospital5, hospital6 } from "../../assets/images";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const partners = [
  {
    id: 1,
    title: "Türkiyə",
    sections: [
    ],
    hospitals: [{ name: "KIMS Hospital", image: hospital1 }, { name: "Yenepoya Hospital", image: hospital2 }],
  },
  {
    id: 2,
    title: "Hindistan",
    sections: [
      "Onkoloji Cərrahiyyə",
      "Ürək Cərrahiyyəsi",
      "Neyrocərrahiyyə",
      "Ümumi Cərrahiyyə",
      "Uşaq Cərrahiyyəsi",
      "Uroloji Cərrahiyyə",
      "Ortopedik Cərrahiyyə"
    ],
    hospitals: [{ name: "Medipol", image: hospital3 }, { name: "Liv Hospital", image: hospital4 }],
  },
];

const PartnersDetail = () => {
  const { id } = useParams();
    const { t } = useTranslation();

  const activePartner = partners.find((partner) => partner.id === parseInt(id));

  if (!activePartner) {
    return <p></p>;
  }

  return (
    <div className="md:max-w-container max-w-containerSm mx-auto mt-6 md:mt-14">
      {/* Breadcrumb */}
      <p>
        {t("Ana səhifə")}{" "}
        <i className="fas fa-chevron-right text-black mx-3" /> {t("Beynəlxalq Əməkdaşlıqlarımız")}{" "}
        <i className="fas fa-chevron-right text-black mx-3" />{" "}
        {t(activePartner.title)}
      </p>

      {/* Partner Başlığı */}
      <div className="mt-6">
        <p className="text-center text-2xl md:text-4xl font-semibold text-[#388e3c]">
          {t(activePartner.title)}
        </p>

        {activePartner.sections && activePartner.sections.length > 0 && (
    <p className="text-2xl md:text-3xl font-medium mt-8">
      {t(activePartner.title)} {t("Tibbi Müşahidə İmkanları")}
    </p>
  )}

        {/* Bölümlerin Listesi */}
        <ul className="mt-4 text-lg md:text-xl list-disc ml-6">
          {activePartner.sections.map((section, index) => (
            <li key={index}>{t(section)}</li>
          ))}
        </ul>

        {/* Xəstəxanalar */}
        <p className="text-2xl md:text-3xl font-medium mt-12">{t("Xəstəxanalar")}</p>
        <div className="grid md:grid-cols-3 gap-10 mt-8">
          {activePartner.hospitals.map((hospital, index) => (
            <div
              key={index}
              className="rounded-lg border border-neutral-200 py-4 px-6"
            >
              <img
                className="w-[90%] mx-auto"
                src={hospital.image}
                alt={hospital.name}
              />
              <p className="text-center text-xl font-medium mt-4">
                {hospital.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnersDetail;
